(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adv-villain"] && !Shopify.designMode) return;
  try {
    
  var villain = document.querySelector('.adv-villain');
  if (villain && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries, observer) {
        if (entries[0].isIntersecting) {
          villain.classList.add('is-inview');
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    ).observe(villain);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dlayr-close"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var close = document.getElementById('dlayr-close');
    if (!close || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        document.body.classList.toggle('dlayr-close-in-view', entries[0].isIntersecting);
      },
      { threshold: 0.25 }
    );
    io.observe(close);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dlayr-hero"] && !Shopify.designMode) return;
  try {
    
  var video = document.querySelector('.dlayr-hero__video');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobile = window.matchMedia('(max-width: 47.9375rem)');

  if (video) {
    var variant = mobile.matches ? 'mobile' : 'desktop';
    video.poster = video.dataset['poster' + (variant === 'mobile' ? 'Mobile' : 'Desktop')];

    if (!reducedMotion.matches) {
      var webm = document.createElement('source');
      webm.src = video.dataset[variant + 'Webm'];
      webm.type = 'video/webm';
      var mp4 = document.createElement('source');
      mp4.src = video.dataset[variant + 'Mp4'];
      mp4.type = 'video/mp4';
      video.append(webm, mp4);
      video.load();

      var playPromise = video.play();
      if (playPromise) playPromise.catch(function () {});

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                video.play().catch(function () {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.1 }
        ).observe(video);
      }
    }
  }

  var sticky = document.querySelector('.dlayr-sticky-cta');
  var heroActions = document.querySelector('.dlayr-hero__actions');
  if (sticky && heroActions) {
    var updateSticky = function () {
      var passed = heroActions.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('is-visible', passed);
      sticky.setAttribute('aria-hidden', String(!passed));
    };
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    updateSticky();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dlayr-mechanism"] && !Shopify.designMode) return;
  try {
    
  var mechanism = document.querySelector('.dlayr-mechanism');
  if (mechanism && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries, observer) {
        if (entries[0].isIntersecting) {
          mechanism.classList.add('is-inview');
          observer.disconnect();
        }
      },
      { threshold: 0.35 }
    ).observe(mechanism);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dlayr-offer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.getElementById('dlayr-offer');
    if (!root || document.body.classList.contains('shopify-design-mode')) return;

    var PRICE = parseFloat(root.getAttribute('data-price-value')) || 59;
    var steps = root.querySelectorAll('[data-res-step]');
    var state = { email: '', name: '', address: '', country: '', beta: false };
    var firedOnce = {};
    var emailPosted = false;
    var recordPosted = false;

    /* Every event fires at most once per page load; Purchase is
       additionally deduped across refreshes via sessionStorage. */
    function track(evt, params) {
      if (firedOnce[evt]) return;
      firedOnce[evt] = true;
      if (typeof fbq !== 'function') return;
      if (params) { fbq('track', evt, params); } else { fbq('track', evt); }
    }

    /* For events fired on page load (the post-navigation Lead and
       Purchase): dedupe via sessionStorage and wait briefly for the
       async pixel script if it hasn't loaded yet. */
    function fireOnce(key, fn) {
      var tries = 0;
      (function attempt() {
        try {
          if (sessionStorage.getItem(key)) return;
          if (typeof fbq === 'function') {
            sessionStorage.setItem(key, '1');
            fn();
          } else if (tries++ < 20) {
            setTimeout(attempt, 250);
          }
        } catch (err) {}
      })();
    }

    function go(n) {
      steps.forEach(function (el) {
        el.hidden = el.getAttribute('data-res-step') !== String(n);
      });
      var card = root.querySelector('.dlayr-offer__card');
      if (card && n > 0) {
        var r = card.getBoundingClientRect();
        if (r.top < 0 || r.top > window.innerHeight * 0.5) {
          card.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }

    /* ViewContent — offer block enters viewport, once */
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          track('ViewContent', { content_name: 'dlayr_offer' });
          vio.disconnect();
        }
      }, { threshold: 0.35 });
      vio.observe(root);
    }

    /* Step 0 → 1 · InitiateCheckout */
    var reserveBtn = root.querySelector('[data-res-reserve]');
    if (reserveBtn) {
      reserveBtn.addEventListener('click', function () {
        track('InitiateCheckout', { value: PRICE, currency: 'USD' });
        go(1);
      });
    }

    /* Step 1 → 2 · Lead + AJAX customer capture (partial-safe:
       he is on the list even if he abandons at step 2 or 3).
       No-JS fallback: the form posts normally (old waitlist path). */
    /* Step 1 → 2 · Lead + NATIVE customer capture.
       Shopify signs form posts server-side — any scripted POST
       returns 400 "invalid parameters" (verified live 2026-08-19).
       So the email step submits for real: we stash the email and
       fire Lead in the submit listener (runs before navigation),
       Shopify signs + accepts the post (challenging it if it wants
       to), return_to lands back on this page, and the resume logic
       below jumps straight to the shipping step. One ~1s reload —
       and the capture is partial-safe: he's on the list even if he
       abandons at step 2 or 3. */
    var emailInput = document.getElementById('dlayr-offer-email');
    var emailForm = emailInput ? emailInput.form : null;
    if (emailForm && emailInput) {
      emailForm.addEventListener('submit', function () {
        /* Stash only — Lead fires on the RETURN page (resume logic).
           Firing before the navigation raced the page teardown and
           lost on mobile (verified live 2026-08-19). No preventDefault:
           the navigation IS the capture. */
        state.email = emailInput.value.trim();
        var betaBox = emailForm.querySelector('[data-dlayr-beta]');
        var tagsInput = emailForm.querySelector('[data-dlayr-tags]');
        state.beta = !!(betaBox && betaBox.checked);
        if (tagsInput) tagsInput.value = state.beta ? 'dlayr-waitlist,dlayr-beta' : 'dlayr-waitlist';
        try {
          sessionStorage.setItem('dlayr_res_email', state.email);
          sessionStorage.setItem('dlayr_res_beta', state.beta ? '1' : '0');
        } catch (err) {}
      });
      /* keep the hidden tag in sync live too (belt and braces) */
      var betaLive = emailForm.querySelector('[data-dlayr-beta]');
      var tagsLive = emailForm.querySelector('[data-dlayr-tags]');
      if (betaLive && tagsLive) {
        betaLive.addEventListener('change', function () {
          tagsLive.value = betaLive.checked ? 'dlayr-waitlist,dlayr-beta' : 'dlayr-waitlist';
        });
      }
    }

    /* Old no-JS success state (post-redirect) still fires Lead */
    var leadMarker = document.querySelector('[data-dlayr-lead]');
    if (leadMarker && !sessionStorage.getItem('dlayr_lead_fired')) {
      sessionStorage.setItem('dlayr_lead_fired', '1');
      if (typeof fbq === 'function') fbq('track', 'Lead');
    }

    /* Step 2 → 3 · AddPaymentInfo (the signal step) */
    var shipForm = document.getElementById('dlayr-res-ship-form');
    if (shipForm) {
      shipForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!shipForm.checkValidity()) {
          shipForm.reportValidity();
          return;
        }
        var f = shipForm.elements;
        state.name = f.name.value.trim();
        state.address = [
          f.address1.value.trim(),
          f.address2.value.trim(),
          f.city.value.trim(),
          f.region.value.trim(),
          f.zip.value.trim()
        ].filter(Boolean).join(', ');
        state.country = f.country.value.trim();
        /* state.beta was set at step 1 and restored from the stash */
        var shipto = root.querySelector('[data-res-shipto]');
        if (shipto) {
          shipto.textContent = 'Ships to: ' + state.name + ' — ' + state.address + ', ' + state.country;
        }
        track('AddPaymentInfo', { value: PRICE, currency: 'USD' });
        go(3);
      });
    }

    /* Step 3 → 4 · Purchase (reservation-marked) + inbox record.
       ⚑ CUTOVER: remove/disable this Purchase fire the day real
       checkout goes live — see section header comment. */
    var confirmBtn = root.querySelector('[data-res-confirm]');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        /* Mark the confirm — the Purchase event itself fires on the
           RETURN page (resume logic), where no navigation can kill
           it. Pre-navigation firing lost the race on mobile. */
        try { sessionStorage.setItem('dlayr_res_confirmed', '1'); } catch (err) {}
        if (!recordPosted) {
          recordPosted = true;
          var recField = root.querySelector('[data-rec="email"]');
          var rec = recField ? recField.form : null;
          if (rec) {
            var set = function (key, val) {
              var el = rec.querySelector('[data-rec="' + key + '"]');
              if (el) el.value = val;
            };
            set('email', state.email);
            set('reservation', 'DLAYR founding drop — 1 bottle at $' + PRICE.toFixed(2));
            set('name', state.name);
            set('address', state.address);
            set('country', state.country);
            set('beta', state.beta ? 'yes' : 'no');
            set('body',
              'RESERVATION (no payment taken) — ' + state.name + ' · ' + state.email +
              ' · ' + state.address + ', ' + state.country +
              ' · beta: ' + (state.beta ? 'yes' : 'no') +
              ' · total reserved: $' + PRICE.toFixed(2)
            );
            /* NATIVE submit — same server-side signing rule as the
               email step; scripted posts are rejected. The confirmed
               flag is set above, so return_to (?reserved=true)
               resumes on the confirmation step and fires Purchase
               there, on settled ground. */
            go(4);
            if (rec.requestSubmit) { rec.requestSubmit(); } else { rec.submit(); }
            return;
          }
        }
        go(4);
      });
    }

    /* Back links — never re-fire events (guarded above) */
    root.querySelectorAll('[data-res-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        go(parseInt(btn.getAttribute('data-res-back'), 10));
      });
    });

    /* RESUME — the flow's memory across the two native submits.
       This is also where Lead and Purchase fire: on the settled
       return page, where no navigation can kill the request.
       · back from the email post (?customer_posted=true): continue
         at the shipping step + fire Lead.
       · back from the record post (?reserved=true, confirmed flag
         set): show the confirmation step + fire Purchase. */
    try {
      var stashedEmail = sessionStorage.getItem('dlayr_res_email');
      if (
        window.location.search.indexOf('reserved=true') !== -1 &&
        sessionStorage.getItem('dlayr_res_confirmed')
      ) {
        sessionStorage.removeItem('dlayr_res_email');
        sessionStorage.removeItem('dlayr_res_beta');
        go(4);
        fireOnce('dlayr_res_purchase_fired', function () {
          fbq('track', 'Purchase', {
            value: PRICE,
            currency: 'USD',
            content_name: 'dlayr_reservation'
          });
        });
      } else if (
        window.location.search.indexOf('customer_posted=true') !== -1 &&
        stashedEmail &&
        !sessionStorage.getItem('dlayr_res_confirmed')
      ) {
        state.email = stashedEmail;
        state.beta = sessionStorage.getItem('dlayr_res_beta') === '1';
        go(2);
        fireOnce('dlayr_lead_fired', function () {
          fbq('track', 'Lead');
        });
      }
    } catch (err) {}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dlayr-pd-offer"] && !Shopify.designMode) return;
  try {
    
  /* beta opt-in → tag swap (same behavior as the sales page) */
  var pdBeta = document.querySelector('[data-dlayr-pd-beta]');
  var pdTags = document.querySelector('[data-dlayr-pd-tags]');
  if (pdBeta && pdTags) {
    pdBeta.addEventListener('change', function () {
      pdTags.value = pdBeta.checked ? 'dlayr-waitlist,dlayr-beta' : 'dlayr-waitlist';
    });
  }

  /* Lead — fires once when the success state renders (post-
     redirect, settled page), deduped per browser session with
     the same key the sales page uses */
  var pdLead = document.querySelector('[data-dlayr-pd-lead]');
  if (pdLead && !sessionStorage.getItem('dlayr_lead_fired')) {
    sessionStorage.setItem('dlayr_lead_fired', '1');
    if (typeof fbq === 'function') fbq('track', 'Lead');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dlayr-reentry"] && !Shopify.designMode) return;
  try {
    
  var litLine = document.querySelector('[data-dlayr-litline]');
  var litReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (litLine && !document.body.classList.contains('shopify-design-mode')) {
    var litWords = litLine.textContent.trim().split(/\s+/);
    litLine.textContent = '';
    litWords.forEach(function (w, i) {
      var span = document.createElement('span');
      span.className = 'dlayr-word';
      span.textContent = w;
      litLine.appendChild(span);
      if (i < litWords.length - 1) litLine.appendChild(document.createTextNode(' '));
    });
    var litSpans = litLine.querySelectorAll('.dlayr-word');

    if (litReduced.matches) {
      litSpans.forEach(function (s) { s.classList.add('is-lit'); });
    } else {
      var litTicking = false;
      var updateLit = function () {
        litTicking = false;
        var rect = litLine.getBoundingClientRect();
        var vh = window.innerHeight;
        var p = (vh * 0.88 - rect.top) / (vh * 0.46);
        p = Math.min(1, Math.max(0, p));
        var lit = Math.round(p * litSpans.length);
        litSpans.forEach(function (s, i) {
          s.classList.toggle('is-lit', i < lit);
        });
      };
      window.addEventListener('scroll', function () {
        if (!litTicking) {
          litTicking = true;
          requestAnimationFrame(updateLit);
        }
      }, { passive: true });
      window.addEventListener('resize', updateLit);
      updateLit();
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dlayr-reset"] && !Shopify.designMode) return;
  try {
    
  var reset = document.querySelector('.dlayr-reset');
  if (reset && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries, observer) {
        if (entries[0].isIntersecting) {
          reset.classList.add('is-inview');
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    ).observe(reset);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
